export { MediaPreviewOnRegionComponent } from './media-preview-on-region.component';


// WEBPACK FOOTER //
// ./src/app/pages/shared/components/media-preview-on-region/index.ts